import React from 'react';
import Link from 'next/link';
import styles from './DescriptionTab.module.css';

interface RegionalDataBannerProps {
    reportId?: string;
    reportTitle?: string;
}

const RegionalDataBanner: React.FC<RegionalDataBannerProps> = ({ reportId, reportTitle }) => {
    const queryParams = new URLSearchParams({
        id: reportId || '',
        name: reportTitle || '',
        type: 'smp'
    }).toString();

    return (
        <div className={styles.regionalDataBanner}>
            <p className={styles.regionalBannerText}>
                Need data on a specific region in this market?
            </p>
            <Link href={`/regional?${queryParams}`} target='_blank'>
                <button className={styles.requestDataButton}>
                    Request Regional Data
                </button>
            </Link>
        </div>
    );
};

export default RegionalDataBanner;
